import React from "react";
import { createRoot } from "react-dom/client";
import App from "./app.jsx";
import "./index.css";

/** Defined before first use: class declarations are in the temporal dead zone. */
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) { return { error }; }

  componentDidCatch(error, info) {
    console.error("render failed", error, info);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="mx-auto grid min-h-screen max-w-md place-items-center p-6 font-sans">
        <div>
          <h1 className="font-serif text-xl text-slate-900">Something went wrong</h1>
          <p className="mt-2 text-sm leading-6 text-slate-600">
            This screen could not load. Reload the app; if the problem continues, contact support.
          </p>
          <button onClick={() => window.location.reload()} className="mt-4 rounded-xl bg-slate-950 px-4 py-2 text-sm font-medium text-white">
            Reload
          </button>
        </div>
      </div>
    );
  }
}

/*
 * App-shell service worker. Secure contexts only — localhost or HTTPS — which
 * is the platform's rule, not ours: on the --lan preview (plain http on a LAN
 * address) navigator.serviceWorker is simply absent and the app runs
 * identically without it. Registration failure is logged, never fatal; the
 * worker is a convenience, not a dependency.
 */
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch((error) =>
      console.warn("service worker not registered:", error?.message ?? error));
  });
}

const root = document.getElementById("root");
if (!root) throw new Error("#root missing from index.html");

createRoot(root).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
